export const copilotDropdownFeatureFlags = ['mim-drafts'] as const;
